import { render } from "./ContractItemSlider.vue?vue&type=template&id=65c4cffd&scoped=true"
import script from "./ContractItemSlider.vue?vue&type=script&lang=js"
export * from "./ContractItemSlider.vue?vue&type=script&lang=js"

import "./ContractItemSlider.vue?vue&type=style&index=0&id=65c4cffd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65c4cffd"

export default script